// import FrontPage from '../page-templates/front-page/front-page';
import Partner from '../page-templates/partner/partner';
import Contact from '../page-templates/contact/contact';
import EmailThankYou from '../page-templates/email-thank-you/email-thank-you';
import FrontPage from '../page-templates/front-page/front-page';
import ProductPage from '../page-templates/woo-product-page/woo-product-page';
import ProductArchive from '../page-templates/woo-product-archive/woo-product-archive';
import DesignCenter from '../page-templates/design-center/designcenter';
import Cart from '../page-templates/cart/cart';
import Checkout from '../page-templates/checkout/checkout';
import Category from '../page-templates/category/category';
import cache from '../src/js/cache';
import MyAccount from '../page-templates/myaccount/my-account';
import { lastClickEl } from '../src/js/const';

/*
|
|--------------------------------------------------------------------------
| Barba - http://barbajs.org/
|--------------------------------------------------------------------------
| Create badass, fluid and smooth transition between your website's pages.
| It helps reducing the delay between your pages, minimizing browser
| HTTP requests and enhancing your user's web experience.
|
*/

//--------------------------------------------------------------------------
// Init Views - Add inits before start so evenest will be fired correctly
//--------------------------------------------------------------------------
FrontPage.init();
ProductPage.init();
ProductArchive.init();
DesignCenter.init();
Contact.init();
EmailThankYou.init();
Partner.init();
Cart.init();
Checkout.init();
MyAccount.init();
Category.init();


//--------------------------------------------------------------------------
// Start Barba
//--------------------------------------------------------------------------
Barba.Pjax.start();
Barba.Prefetch.init();
Barba.Pjax.cacheEnabled = false;


//--------------------------------------------------------------------------
// Find the last link clicked so it can be used by transition-controller.js
//--------------------------------------------------------------------------
Barba.Dispatcher.on('linkClicked', (el) => {
    cache.set(lastClickEl,el);
});

//--------------------------------------------------------------------------
// Add no-barba to wp-admin header bar
//--------------------------------------------------------------------------
$( document ).ready(function() {
    $('#wpadminbar a').addClass('no-barba');
});


//
// Barba.Pjax.preventCheck = function(evt, element) {
//     if (!Barba.Pjax.originalPreventCheck(evt, element)) {
//         return false;
//     }
//
//
//     let href = element.href.toLowerCase()
//     // No need to check for element.href -
//     // originalPreventCheck does this for us! (and more!)
//     if (/info-page/.test(href) || /.pdf/.test(href)) {
//         return false;
//     }
//
//     return true;
// };


